<script lang="js">
  import { fly } from "svelte/transition";

  let user_name = "";
  let ready = false;
  let username_valid = false;
  let counter = 0;
  let team = {};

  const teams = [
    {
        "letters": [
            "a",
            "b",
            "c",
            "d",
            "e"
        ],
        "color": "#FF3505",
        "name": "🦊"
    },
    {
        "letters": [

            "f",
            "g",
            "h",
            "i",
            "j"
        ],
        "color": "#43F505",
        "name": "🐸"
    },
    {
        "letters": [
            "k",
            "l",
            "m",
            "n",
            "o"
        ],
        "color": "#676B6F",
        "name": "🐭"
    },
    {
        "letters": [
            "p",
            "q",
            "r",
            "s",
            "t"
        ],
        "color": "#05CEFF",
        "name": "🐟"
    },
    {
        "letters": [
            "u",
            "v",
            "w",
            "x",
            "y",
            "z"
        ],
        "color": "#F5CC10",
        "name": "🦁"
    }
]

  //test

  async function send() {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({
        client_timestamp: new Date().toISOString(),
        name: user_name,
      }),
    };

    const res = await fetch("api/sendEvent", requestOptions);
    const status = res.status;
    if (status > 200 && status < 299) counter++;
  }

  const check_username = async () => {
    username_valid = user_name.length > 0;
  };

  const activate = async () => {
    await get_team();
    ready = true;
  };

  async function get_team() {
    const first_letter = user_name.charAt(0).toLowerCase();
    teams.forEach((this_team) => {
      if (this_team.letters.includes(first_letter)) {
        team = this_team;
      }
    });
    // fallback
    if (Object.keys(team).length === 0 && team.constructor === Object) {
      Object.assign(team, teams[0]);
    }
  }
</script>

<div
  class="box has-background-light is-bordered has-shadow halftransparent mt-6"
>
  <h2 class="title is-2 has-text-grey-light">Sample Event Emitter</h2>
  <div class="columns">
    {#if ready}
      <div class="column is-fullwidth">
        <div class="field">
          <label class="has-text-grey-light" for="name">
            Thank you {user_name}. You were assigned to
            <span
              style="font-size: x-large;color:{team.color};font-weight:bold; "
            >
              Team {team.name}
            </span> <br />
            Now click the buttton as fast as you can.</label
          >
          <div class="control is-expanded">
            <button
              type="button"
              id="clickbtn"
              class="mt-4 button is-large has-text-dark"
              style="background-color: {team.color}"
              value="Submit Event"
              on:mousedown|preventDefault={send}
            >
              <span class="icon">
                <i class="fas fa-tower-broadcast " />
              </span><span>send Data </span>
            </button>

            <!-- {#if counter > 0} -->
            <span class="label has-text-grey-light">
              {counter} Events sent
            </span>
            <!-- {/if} -->
          </div>
        </div>
      </div>
    {/if}
    {#if !ready}
      <div class="column is-fullwidth">
        <label class="label has-text-grey-light" for="name">Your Name</label>
        <div class="field has-addons">
          <div class="control e">
            <input
              id="name"
              class="input is-large"
              type="text"
              placeholder=""
              bind:value={user_name}
              on:input={check_username}
            />
          </div>

          {#if username_valid}
            <div class="control" transition:fly={{ x: -100, duration: 300 }}>
              <button
                class="button is-large is-success"
                on:click|preventDefault|once={activate}
              >
                <span class="icon">
                  <i class="fas fa-check" />
                </span>
                <span>Ok</span>
              </button>
            </div>
          {/if}
        </div>
      </div>
    {/if}
  </div>
</div>
